import { Link } from "react-router-dom";
import { hotArticles, categories } from "@/mocks/articles";
import { useState } from "react";

export default function CategoryTabs() {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredArticles = activeCategory === "all"
    ? hotArticles
    : hotArticles.filter((a) => a.category === activeCategory);

  const activeCatName = activeCategory === "all" ? "全部" : categories.find((c) => c.slug === activeCategory)?.name || "";

  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-1">{activeCatName}分类下的热门内容</p>
          </div>
          <Link
            to={`/category/${activeCategory === "all" ? "remen" : activeCategory}`}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-8">
          <button
            onClick={() => setActiveCategory("all")}
            className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
              activeCategory === "all"
                ? "bg-primary-500 text-background-50"
                : "bg-background-200 text-foreground-600 hover:bg-background-300"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1.5 ${
                activeCategory === cat.slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600 hover:bg-background-300"
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className={`${cat.icon} text-sm`}></i></span>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filteredArticles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium backdrop-blur-sm">
                    {categories.find((c) => c.slug === article.category)?.name}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="w-7 h-7 rounded-full bg-accent-500 text-background-50 flex items-center justify-center">
                    <i className="ri-fire-line text-sm"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug font-heading mb-3">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.published_at}</span>
                  <span className="flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-eye-line"></i></span>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}